
import {
  ADD_TOKEN,
  ADD_USER,
  DELETE_TOKEN,
	GLOBAL_VARIABLE_ADD_categorias,

} from '../types/auth.types';

const loftyFunctionPlusArray = (array, field) => {
  try {
    let sum = 0;
    array.forEach(item => {
        sum += item[field];
    });
    return sum;
  } catch (error) {
    return 0;
  }
}

const loftyFunctionPlusShoppingCart = (array, field) => {
  try {
    let sum = 0;
    array.forEach(item => {
        sum += item.cartitem[field] * item.quantity;
    });
    return sum;
  } catch (error) {
    return 0;
  }
}

const initialState = {
  loftytoken: localStorage.getItem('loftytoken'),
  loftyuser: undefined,
	lofty_global_categorias: undefined,

};

const reducerAuth = (state = initialState, {type, payload}) => {
  switch (type) {
    case ADD_TOKEN:
      return {
        ...state,
        token: payload?.loftytoken,
        user: payload?.loftyuser,
      };
    case DELETE_TOKEN:
      return {
        ...state,
        token: undefined,
        user: undefined,
      };
    case ADD_USER:
      return {
        ...state,
        user: payload?.loftyuser,
      };
    case GLOBAL_VARIABLE_ADD_categorias:
			return {
				...state,
				lofty_global_categorias: payload.lofty_global_categorias,
			};

    default:
      return state;
  }
};

export default reducerAuth;
